var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$apollo.loading)?_c('v-layout',[_c('v-flex',[_c('preview',{attrs:{"background-image-url":_vm.backgroundImageURL,"items":_vm.items,"height":_vm.height,"width":_vm.width,"accreditation":_vm.accreditation,"attendee-fields":_vm.attendeeFields},on:{"on-ready":_vm.openPrint}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }